import * as TabsStyle from './tabs.css';

export {
  TabsStyle
};

export default {
  TabsStyle
};
